/* eslint-disable no-invalid-this */
/* eslint-disable new-cap */
import {html} from 'lit';
import {createRef, ref} from 'lit/directives/ref.js';
import {FacetBasic} from '../facet-basic/facet-basic';
import styles from './facet-diamond-labgrown.component.scss?as=stylesheet';
import {defineCustomElement} from 'extensions/utils';

class FacetDiamondLabgrown extends FacetBasic {

	static get styles () {
		return [
			...super.styles,
			styles
		];
	}

	static get properties () {
		return {
			...super.properties,
			store: {
				state: true,
				type: Object
			}
		};
	}

	toggle = createRef();

	constructor () {
		super();

		/**
		 * @type {import('extensions/ring-builder/data/ring-builder-store').RingBuilderStore}
		 */
		this.store = {};
	}

	handleChange () {
		this.store?.diamond?.setLabGrown(this.toggle?.value?.checked);
	}

	handleKeyPress = (e) => {
		if (e.keyCode === 13) {
			this.toggle.value.checked = !this.toggle.value.checked;
			this.handleChange();
		}
	}

	renderFacetValues () {
		const labValue = this.facet?.values.filter((value) => {
			// eslint-disable-next-line eqeqeq
			return value.value == 1;
		}).pop();

		return html`
			<input class="toggle-input" id="toggle" type="checkbox" @change="${this.handleChange}" ?checked="${labValue?.selected}" ${ref(this.toggle)}>
			<label for="toggle" class="toggle-label" aria-label="${labValue?.selected ? 'Lab Diamond' : 'Natural Diamond'}">
				<div class="facet--option facet--natural" tabindex="${labValue?.selected ? 0 : -1}" @keypress="${this.handleKeyPress}">
					Natural Diamond
				</div>

				<span class="facet--switch"></span>

				<div class="facet--option facet--lab" tabindex="${labValue?.filtered ? -1 : 0}" @keypress="${this.handleKeyPress}">
					Lab Diamond
				</div>
			</label>
		`;
	}

	render () {
		let tooltipLabel = 'Learn';
		if (this.store?.screenSize === 'desktop') {
			tooltipLabel = 'Learn More';
		}
		return html`
			<div class="facet">
				<div class="facet--options">
					${this.renderFacetValues()}
				</div>
				<rb-tooltip class="facet-tooltip" label="${ tooltipLabel }" code="${this.facet?.field}" title="${this.facet.title}" endpoint="${this.apiEndpoint}"></rb-tooltip>
			</div>
		`;
	}

};

defineCustomElement('rb-facet-diamond-labgrown', FacetDiamondLabgrown);
